"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeddyToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_teddyDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "contract ITeddyDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
            {
                internalType: "contract ITeddySeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DescriptorLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ITeddyDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "DescriptorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MinterLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "SeederLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ITeddySeeder",
                name: "seeder",
                type: "address",
            },
        ],
        name: "SeederUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "TeddyBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                indexed: false,
                internalType: "struct ITeddySeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "TeddyCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "teddyDAO",
                type: "address",
            },
        ],
        name: "TeddyDAOUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DELEGATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "teddyId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                internalType: "uint96",
                name: "votes",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "descriptor",
        outputs: [
            {
                internalType: "contract ITeddyDescriptorMinimal",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCurrentVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPriorVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDescriptorLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMinterLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSeederLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "mintCustomTeddy",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seeder",
        outputs: [
            {
                internalType: "contract ITeddySeeder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "seeds",
        outputs: [
            {
                internalType: "uint48",
                name: "background",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "body",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "headAccessory",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "bodyAccessory",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "face",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newContractURIHash",
                type: "string",
            },
        ],
        name: "setContractURIHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITeddyDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
        ],
        name: "setDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITeddySeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        name: "setSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_teddyDAO",
                type: "address",
            },
        ],
        name: "setTeddyDAO",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "teddyDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "votesToDelegate",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class TeddyToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_teddyDAO, _minter, _descriptor, _seeder, overrides) {
        return super.deploy(_teddyDAO, _minter, _descriptor, _seeder, overrides || {});
    }
    getDeployTransaction(_teddyDAO, _minter, _descriptor, _seeder, overrides) {
        return super.getDeployTransaction(_teddyDAO, _minter, _descriptor, _seeder, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TeddyToken__factory = TeddyToken__factory;
TeddyToken__factory.bytecode = _bytecode;
TeddyToken__factory.abi = _abi;
